import axios from 'axios';
import { isEmpty } from 'lodash';
import pathfinder from '@fiverr-private/pathfinder';
import { logger, stats } from '@fiverr-private/obs';
import { FETCH_INITIAL_DATA_FAILURE, FETCH_INITIAL_DATA_SUCCESS } from '../ContactSellerModal/metrics';
import { STATS_METRIC_PREFIX } from '../ContactSellerModal/constants';
import { fetchHourlyRate } from './getHourlyRate';

export const fetchInitialData = async(recipientName) => {
    try {
        const url = pathfinder('send_message_initial_data', { recipient_username: recipientName });
        const promises = await Promise.allSettled([
            fetchHourlyRate(recipientName),
            axios.get(url)
        ]);
        const [
            hourlyRateResponse,
            initialDataResponse
        ] = promises.map(
            (response) => (response.status === 'fulfilled' ? response : null)
        );

        if (!initialDataResponse) {
            throw new Error('Failed to fetch initial data');
        }

        const { data } = initialDataResponse.value;

        data.recipient.username = recipientName;
        const utcOffset = parseInt(data.recipient?.utcOffset, 10);
        if (isNaN(utcOffset)) {
            logUtcOffsetWarning(utcOffset, recipientName);
        }

        countSuccess();

        data.recipient.offersHourlyRate = !isEmpty(hourlyRateResponse?.value?.id);
        return data;
    } catch (error) {
        countFailure();
        logError(error, recipientName);
        throw error;
    }
};

const countFailure = () => {
    stats.count(STATS_METRIC_PREFIX, FETCH_INITIAL_DATA_FAILURE);
};

const countSuccess = () => {
    stats.count(STATS_METRIC_PREFIX, FETCH_INITIAL_DATA_SUCCESS);
};

const logError = (error, recipientName) => {
    logger.error(error, {
        details: 'Failed to fetch initial data',
        recipientName
    });
};

const logUtcOffsetWarning = (utcOffset, recipientName) => {
    logger.warn('Invalid utcOffset returned from send_message_initial_data', {
        utcOffset,
        recipientName
    });
};
